import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import SEO from "../components/seo"

const Layout = ({ location, children }) => (
  <>
    <SEO location={location} />
    <Helmet>
      <body className="relative font-sans bg-grey-light text-base text-charcoal leading-base tracking-base min-h-screen js-body" />
    </Helmet>
    {children}
  </>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
